export const CONSTANTS = {
    MAX_POPUP_SCREEN_SM: 575,
    MAX_POPUP_SCREEN_MD: 767,
    MAX_UPLOADED_FILE_SIZE: 15 * 1024 * 1024, // 15MB
};
